var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:("lang-" + (_vm.$i18nState.locale)),attrs:{"id":"app"}},[_c('div',{staticClass:"header"},[_c('Header')],1),_vm._v(" "),_c('router-view',{key:_vm.key}),_vm._v(" "),_c('div',{staticClass:"footer"},[_c('Footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-efba399e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 